import React from 'react';
import { ProjectEquipmentStats } from './ProjectEquipmentStats';
import { ProjectEquipmentValueDistribution } from './ProjectEquipmentValueDistribution';
import { ProjectEquipmentUpcomingMaintenance } from './ProjectEquipmentUpcomingMaintenance';
import { ProjectEquipmentUtilization } from './ProjectEquipmentUtilization';

export function ProjectEquipmentSidebar({ data }: { data: any }) {
  return (
    <div className="space-y-6">
      {/* Thống kê thiết bị */}
      <ProjectEquipmentStats />

      {/* Giá trị thiết bị theo trạng thái */}
      <ProjectEquipmentValueDistribution />

      {/* Sắp tới bảo dưỡng */}
      <ProjectEquipmentUpcomingMaintenance maintenance={data.upcomingMaintenance} />

      {/* Hiệu suất sử dụng */}
      <ProjectEquipmentUtilization />
    </div>
  );
}
